import { Skeleton } from '../ui/skeleton';
import { useState } from 'react';
import MusicNote from './MusicNote';

const Avatar = ({
  src,
  name,
  size = 'md',
  loading = false,
}: {
  src?: string | null;
  name?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  loading?: boolean;
}) => {
  const [imageLoadError, setImageLoadError] = useState(false);

  const sizeMap = {
    sm: { avatarSize: 36, fontSize: 16 },
    md: { avatarSize: 44, fontSize: 18 },
    lg: { avatarSize: 80, fontSize: 32 },
    xl: { avatarSize: 120, fontSize: 48 },
  };

  const { avatarSize, fontSize } = sizeMap[size] || sizeMap['md'];

  // Show skeleton if loading or src is null
  if (loading || src === null) {
    return (
      <Skeleton
        className='rounded-full'
        style={{ width: avatarSize, height: avatarSize }}
      />
    );
  }

  // Show avatar image if src is valid and no load error
  if (src && !imageLoadError) {
    return (
      <img
        width={avatarSize}
        height={avatarSize}
        alt={name ? `${name}'s Avatar` : 'User Avatar'}
        src={src}
        className='rounded-full aspect-square object-cover'
        onLoad={() => {
          setImageLoadError(false);
        }}
        onError={() => {
          setImageLoadError(true);
        }}
      />
    );
  }

  // Show musical note as fallback
  console.log('🎵 Showing MusicNote component');
  return (
    <MusicNote
      name={name || 'Anonymous'}
      size={avatarSize}
      fontSize={fontSize}
    />
  );
};

function stringToHslColor(str: string, s: number, l: number) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const h = hash % 360;
  return `hsl(${h}, ${s}%, ${l}%)`;
}

export default Avatar;
